import { render, staticRenderFns } from "./SelectContact.vue?vue&type=template&id=011824c0&scoped=true&lang=pug"
import script from "./SelectContact.vue?vue&type=script&lang=js"
export * from "./SelectContact.vue?vue&type=script&lang=js"
import style0 from "./SelectContact.vue?vue&type=style&index=0&id=011824c0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011824c0",
  null
  
)

export default component.exports